module.exports = __webpack_public_path__ + "img/主题平面.c48c0433.png";